// Localize & Translations
import locales from "../locales";
import { initLocalize } from "@france/superelements/utils/lib";
import initOneSignal from "./onesignal/onesignal";
import { errorLog } from "../utils/debugLog";

let itDidRun = false;

export const initApp = async (callback: () => void) => {
  console.info("Initializing Localize...");
  await initLocalize(locales);
  console.info("Localize Initialized.");
  try {
    setTimeout(() => {
      if (!itDidRun) callback();
    }, 3000);

    console.info("Initializing OneSignal...");
    await initOneSignal();
    console.info("OneSignal Initialized.");
  } catch (err) {
    errorLog(err);
  }
  itDidRun = true;
  callback();
};
